





































































































































import Vue, { PropType } from 'vue';
import WidgetWrapper from '@/components/widgets/WidgetWrapper.vue';
import FieldInput from '@/components/form/FieldInput.vue';
import FieldSelect from '@/components/form/FieldSelect.vue';
import { DropdownList, EImpressions, ETargetTypes } from '@/types';
import { BuyingStrategyData } from '@/types/campaign/settings';

export default Vue.extend({
  name: 'TheBuyingStrategy',
  components: { WidgetWrapper, FieldInput, FieldSelect },

  props: {
    data: {
      type: Object as PropType<BuyingStrategyData>,
      required: true,
    },
  },

  watch: {
    data(newValue) {
      this.campaign = newValue;
    },
  },

  computed: {
    targetTypes(): Array<DropdownList> {
      return [
        {
          label: this.$t(
            'pages.campaignForm.tabs.options.blocks.priceModel.impression'
          ),
          value: ETargetTypes.CPM,
        },
        {
          label: this.$t(
            'pages.campaignForm.tabs.options.blocks.priceModel.clicks'
          ),
          value: ETargetTypes.CPC,
        },
      ];
    },
    impressions(): Array<DropdownList> {
      return [
        {
          label: this.$t(
            'pages.campaignForm.tabs.options.blocks.priceModel.fixedCpm'
          ),
          value: EImpressions.FIXED_CPM,
        },
        {
          label: this.$t(
            'pages.campaignForm.tabs.options.blocks.priceModel.percentageFloor'
          ),
          value: EImpressions.PERCENTAGE_FLOOR,
        },
      ];
    },
    targetTypeCPM(): string {
      return ETargetTypes.CPM;
    },
    targetTypeCPC(): string {
      return ETargetTypes.CPC;
    },
    impressionFixedCPM(): string {
      return EImpressions.FIXED_CPM;
    },
    impressionPercentageFloor(): string {
      return EImpressions.PERCENTAGE_FLOOR;
    },
    maxCpmIsShow(): boolean {
      return (
        this.campaign.target_type === this.targetTypeCPC ||
        (this.campaign.target_type === this.targetTypeCPM &&
          this.campaign.impression === this.impressionFixedCPM) ||
        this.campaign.impression === this.impressionPercentageFloor
      );
    },
    increaseOnIsShow(): boolean {
      return (
        this.campaign.target_type === this.targetTypeCPM &&
        this.campaign.impression === this.impressionPercentageFloor
      );
    },
  },

  methods: {
    change(name, value) {
      this.$emit('changeCampaign', name, value);
    },
    changeChecked(checked) {
      this.change('is_use_price_setting', checked);
    },
  },

  data() {
    return {
      campaign: this.data,
    };
  },
});
